import Link from "next/link";
import { navLinks } from "@/constants/navigation";

interface DesktopMenuProps {
  hidden: boolean;
}

export function DesktopMenu({ hidden }: DesktopMenuProps) {
  if (hidden) return null;

  return (
    <nav
      aria-label="Primary navigation"
      className="hidden items-center gap-[clamp(20px,3vw,44px)] md:flex"
    >
      {navLinks.map((link) => (
        <Link
          key={link.href}
          href={link.href}
          className="group relative pb-1 text-xs font-medium uppercase tracking-[3px] text-paper transition-colors duration-200 hover:text-amber"
        >
          {link.label}
          <span className="absolute bottom-0 left-0 h-px w-0 bg-amber transition-all duration-300 group-hover:w-full" />
        </Link>
      ))}
    </nav>
  );
}